<template>
  <div class="e-stamp-record" v-stat.brow="{ tag: 'estamp-record.page_brow|印花记录页面曝光' }">
    <section class="month-picker-section">
      <MonthPicker></MonthPicker>
    </section>
    <NotifyMessage class="notification-message-section"></NotifyMessage>
    <section class="kind-tabs-section">
      <KindTabs></KindTabs>
    </section>
    <section class="record-list-section">
      <RecordList></RecordList>
    </section>
    <section class="action-btns-section">
      <FitButton
        type="default"
        size="small"
        @click="goToMyCoupon"
        v-stat.click="{ tag: 'estamp-record.viewcoupon_btn_click|底部查看优惠券按钮点击' }"
      >{{ i18n('我的優惠券') }}</FitButton>
      <FitButton
        type="primary"
        size="small"
        @click="goToHome"
        v-stat.click="{ tag: 'estamp-record.gohome_btn_click|底部回到首页按钮点击' }"
      >{{ i18n('回到首页') }}</FitButton>
    </section>
  </div>
</template>

<script>
import MonthPicker from './components/month-picker/index.vue';
import NotifyMessage from './components/notify-message/index.vue';
import KindTabs from './components/kind-tabs/index.vue';
import RecordList from './components/record-list/index.vue';
import { FitButton } from '@tencent/wphk-ui';
import { defineComponent } from '@vue/composition-api';
import { windowHelper } from '@tencent/ppd-base-libs';
import { i18n } from './i18n';

export default defineComponent({
  components: {
    MonthPicker,
    NotifyMessage,
    KindTabs,
    RecordList,
    FitButton,
  },
  setup() {
    return { i18n };
  },
  methods: {
    goToHome() {
      this.$router.replace('/homev2');
    },
    goToMyCoupon() {
      windowHelper.redirect('https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml?page=couponlist', 300);
    },
  },
  mounted() {
    document.title = i18n('印花記錄');
  },
});
</script>

<style scoped lang="less">
@rem: 200rem;

.e-stamp-record {
  @offset: 64/@rem;

  margin: 0 32/@rem;
  width: calc(100vw ~'-' @offset);
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.month-picker-section {
  text-align: center;
  margin-top: 48/@rem;
}

.notification-message-section {
  margin-top: 16/@rem;
}

.kind-tabs-section {
  margin-top: 16/@rem;
  text-align: center;
}

.record-list-section {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  &::after {
    content: '';
    display: block;
    background: linear-gradient(to top, #fff, rgba(255,255,255,0));
    width: 100%;
    height: 120/@rem;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.action-btns-section {
  text-align: center;
  padding: 64/@rem 0;
  padding-bottom: 64/@rem;
}

.action-btns-section /deep/ .weui-btn {
  margin: 0 32/@rem;
  width: 240/@rem;
  height: 80/@rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 34/@rem;
}
</style>
